module.exports = __webpack_public_path__ + "img/fzxc1.48e6046e.png";